import React, { createContext } from 'react';

export const ApiContext = createContext();

export const ApiProvider = ({ children }) => {
    const apiUrl = process.env.REACT_APP_API_URL || '';
    // console.log("API URL:", apiUrl);

    return (
        <ApiContext.Provider value={apiUrl}>
            {children}
        </ApiContext.Provider>
    );
};
